import React, { useState, useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { AppConfig, TRADE_REFERENCE_STATUS, roles } from "../../../configs/admin-config";
import { useHistory } from "react-router-dom";
import MuiAlert from "@mui/material/Alert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Grid,
  InputBase,
  Backdrop,
  CircularProgress,
  Snackbar,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getAccessToken } from "../../../utils/oauth";
import TablePagination from "@mui/material/TablePagination";
import CachedIcon from "@mui/icons-material/Cached";
import IconButton from "@mui/material/IconButton";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { checkIfRoleExists } from "../../../utils/oauth";

const useStyles = makeStyles()((theme) => {
  const baseResultChip = {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid",
    borderRadius: "16px",
    padding: "4px 12px",
    fontSize: "11px",
  };

  return {
    backdrop: {
      zIndex: 2,
      color: "white",
    },
    root: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      border: "1px solid #AAA",
    },
    searchGrid: {
      marginBottom: 20,
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    accordionSummary: {
      backgroundColor: theme.palette.primary.light,
      borderRadius: "4px",
    },
    accordionHeading: {
      fontSize: 14,
      fontWeight: 500,
    },
    accordionDetails: {
      display: "block",
    },
    filterGrid: {
      display: "flex",
      alignItems: "center",
    },
    filterLabel: {
      fontSize: 14,
    },
    table: {
      minWidth: 650,
    },
    column: {
      cursor: "pointer",
      "&:hover": {
        fontWeight: 600,
      },
    },
    tableContainer: {
      marginTop: 20,
    },
    tableHead: {
      backgroundColor: theme.palette.primary.light,
    },
    tableRow1: {
      "&:hover": {
        backgroundColor: "#F5F5F5",
        cursor: "pointer",
      },
    },
    tableRow2: {
      "&:hover": {
        cursor: "not-allowed",
      },
    },
    primaryText: {
      color: theme.palette.primary.main,
      fontSize: 12,
      fontWeight: "bold",
    },
    secondaryText: {
      color: theme.palette.secondary.main,
      fontSize: 12,
      fontWeight: "bold",
    },
    statusChip: {
      fontWeight: "bold",
      fontSize: 11,
    },
    button: {
      backgroundColor: "white",
      textTransform: "none",
      fontSize: 11,
    },
    msgTypo: {
      paddingTop: 20,
      textAlign: "center",
      color: theme.palette.secondary.main,
    },
    renewButton: {
      textTransform: "none",
    },
    copyButton: {
      textTransform: "none",
    },
    resultChipSecondary: {
      ...baseResultChip,
      color: theme.palette.secondary.main,
    },
    resultChipPrimary: {
      ...baseResultChip,
    },
  };
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const TradeReferences = ({ id }) => {
  let query = useQuery();

  const { classes } = useStyles();
  const history = useHistory();

  const [tradeReferences, setTradeReferences] = useState([]);
  const [filteredTradeReferences, setFilteredTradeReferences] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [successSnack, setSuccess] = useState(false);
  const [sortColumn, setSortColumn] = useState("Partner Company");
  const [sortPriority, setSortPriority] = useState("DESC");
  const [priorityChanged, setPriorityChanged] = useState(false);
  const [copySnack, setCopy] = useState(false);
  const [failSnack, setFail] = useState(false);
  const [backdropOpen, setbackDrop] = useState(true);
  const [formStatusFilters, setFormStatusFilters] = useState({
    completed: true,
    drafted: true,
    pending: true,
    rejected: true,
    deactivated: true,
    // requestedToEdit: true,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snack, setSnackBar] = useState({ visibility: false, severity: "", message: "" });

  const getTradeReferences = async () => {
    const requestURL = AppConfig.baseUrl + AppConfig.getTradeReferences;

    try {
      let response = await fetch(requestURL, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });
      let body = await response.json();
      if (response.status === 200) {
        if (body) {
          let refs = [];
          let links = [];
          let resellers = [];
          if (body.tradeReferences.length > 0) {
            refs = body.tradeReferences;
          }

          if (body.tradeReferenceLinks.length > 0) {
            links = body.tradeReferenceLinks;
          }

          if (body.resellers.length > 0) {
            resellers = body.resellers;
          }

          let tradeRefLinks = [];
          links.map((link) => {
            const linkId = link.linkId;
            const companyName =
              refs.filter((ref) => ref.linkId === linkId && ref.subQuestionId === 27).length > 0
                ? refs.filter((ref) => ref.linkId === linkId && ref.subQuestionId === 27)[0].answer
                : null;
            const resellerCompanyName =
              resellers.filter((res) => res.companyId === link.companyId).length > 0
                ? resellers.filter((res) => res.companyId === link.companyId)[0].companyName
                : "-";
            link["companyName"] = companyName || link.companyName;
            link["resellerCompanyName"] = resellerCompanyName;
            tradeRefLinks.push(link);
          });
          setTradeReferences(tradeRefLinks);
          if (query.get("id")) {
            setFilteredTradeReferences(
              sortRows(
                tradeRefLinks.filter((item) => item.linkId === query.get("id")),
                "Partner Company"
              )
            );
          } else {
            setFilteredTradeReferences(sortRows(tradeRefLinks, "Partner Company"));
          }
        } else {
          console.warn("Not retrieved any data from backend");
        }
      } else {
        console.error(body.message);
      }

      setbackDrop(false);
      return null;
    } catch (error) {
      setbackDrop(false);
      console.error(error);
      return error;
    }
  };

  useEffect(() => {
    setbackDrop(true);
    getTradeReferences();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredTradeReferences.length - page * rowsPerPage);

  const openTradeRef = (tradeRef) => {
    if (tradeRef.status === TRADE_REFERENCE_STATUS.COMPLETED || tradeRef.status === TRADE_REFERENCE_STATUS.DRAFTED || tradeRef.status === TRADE_REFERENCE_STATUS.ACTIVE) {
      history.push({
        pathname:
          AppConfig.urls.ADMIN + AppConfig.urls.TRADE_REFERENCE_FORM + tradeRef.companyId + "/" + tradeRef.linkId,
        state: { encodeString: tradeRef.encodeString },
      });
    } else if (tradeRef.status === TRADE_REFERENCE_STATUS.DEACTIVATED) {
      history.push({
        pathname:
          AppConfig.urls.ADMIN + AppConfig.urls.DEACTIVATED_PAGE + tradeRef.linkId,
        state: { item: tradeRef, encodeString: tradeRef.encodeString },
      });
    } else if (tradeRef.status === TRADE_REFERENCE_STATUS.REJECTED) {
      history.push({
        pathname:
          AppConfig.urls.ADMIN + AppConfig.urls.REJECTED_PAGE + tradeRef.companyId + "/" + tradeRef.linkId,
        state: { item: tradeRef, encodeString: tradeRef.encodeString },
      });
    }  else {
      history.push({
        pathname: AppConfig.urls.ADMIN + AppConfig.urls.PENDING_PAGE_2 + tradeRef.linkId,
        state: { item: tradeRef, encodeString: tradeRef.encodeString },
      });
    }
  };

  const handleSearch = (e) => {
    const input = e.target.value;
    setSearchInput(input);
  };

  const handleFormStatusFilters = (e) => {
    setFormStatusFilters((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccess(false);
    setFail(false);
    setCopy(false);
    setSnackBar({ visibility: false, severity: "", message: "" });
  };

  const sortRows = (array, sortColumn) => {
    if (sortPriority === "DESC") {
      if (sortColumn === "Partner Company") {
        return array.sort((a, b) =>
          a.resellerCompanyName > b.resellerCompanyName ? 1 : b.resellerCompanyName > a.resellerCompanyName ? -1 : 0
        );
      } else if (sortColumn === "Reference Company") {
        return array.sort((a, b) => (a.companyName > b.companyName ? 1 : b.companyName > a.companyName ? -1 : 0));
      } else if (sortColumn === "Contact Email") {
        return array.sort((a, b) => (a.email > b.email ? 1 : b.email > a.email ? -1 : 0));
      } else if (sortColumn === "Form Status") {
        return array.sort((a, b) => (a.status > b.status ? 1 : b.status > a.status ? -1 : 0));
      } else {
        return array;
      }
    } else {
      if (sortColumn === "Partner Company") {
        return array.sort((a, b) =>
          a.resellerCompanyName > b.resellerCompanyName ? -1 : b.resellerCompanyName > a.resellerCompanyName ? 1 : 0
        );
      } else if (sortColumn === "Reference Company") {
        return array.sort((a, b) => (a.companyName > b.companyName ? -1 : b.companyName > a.companyName ? 1 : 0));
      } else if (sortColumn === "Contact Email") {
        return array.sort((a, b) => (a.email > b.email ? -1 : b.email > a.email ? 1 : 0));
      } else if (sortColumn === "Form Status") {
        return array.sort((a, b) => (a.status > b.status ? -1 : b.status > a.status ? 1 : 0));
      } else {
        return array;
      }
    }
  };

  const setSortColumnValue = (columnName) => {
    setPriorityChanged(true);
    setSortColumn(columnName);
    setFilteredTradeReferences(sortRows(filteredTradeReferences, columnName));
    if (sortPriority === "ASC") {
      setSortPriority("DESC");
    } else {
      setSortPriority("ASC");
    }
  };

  useEffect(() => {
    setSortPriority("ASC");
    setFilteredTradeReferences(sortRows(filteredTradeReferences, sortColumn));
  }, [sortColumn]);

  useEffect(() => {
    if (tradeReferences.length > 0) {
      var filteredResellerList = [];

      if (formStatusFilters.completed) {
        filteredResellerList = tradeReferences.filter((res) => res.status === TRADE_REFERENCE_STATUS.COMPLETED);
      }

      if (formStatusFilters.drafted) {
        filteredResellerList = tradeReferences.filter((res) => res.status === TRADE_REFERENCE_STATUS.DRAFTED).concat(filteredResellerList);
      }

      if (formStatusFilters.pending) {
        filteredResellerList = tradeReferences.filter((res) => res.status === "active").concat(filteredResellerList);
      }

      if (formStatusFilters.deactivated) {
        filteredResellerList = tradeReferences.filter((res) => res.status === TRADE_REFERENCE_STATUS.DEACTIVATED).concat(filteredResellerList);
      }

      if (formStatusFilters.rejected) {
        filteredResellerList = tradeReferences.filter((res) => res.status === TRADE_REFERENCE_STATUS.REJECTED).concat(filteredResellerList);
      }

      // if (formStatusFilters.requestedToEdit) {
      //   filteredResellerList = tradeReferences.filter((res) => res.status === "pending").concat(filteredResellerList);
      // }
      setFilteredTradeReferences(filteredResellerList);
    }
  }, [formStatusFilters]);

  const renderIndicator = (columnName) => {
    if (sortColumn === columnName && priorityChanged) {
      if (sortPriority === "ASC") {
        return <span style={{ fontSize: 20 }}>&#8595;</span>;
      } else {
        return <span style={{ fontSize: 20 }}>&#8593;</span>;
      }
    }
  };

  const renewTradeReferenceLink = async(linkId) => {
    setbackDrop(true);
    const requestURL = AppConfig.baseUrl + AppConfig.tradeReferenceData + "link/" + linkId + "/" + AppConfig.renewLink;
    try {
      let response = await fetch(requestURL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      });
      setbackDrop(false);
      if (response.status === 200) {
        setSnackBar({ visibility: true, severity: "success", message: "Trade Reference Link Renewed Successfully" });
      } else {
        setSnackBar({ visibility: true, severity: "error", message: "Something went wrong while renewing Trade Reference link" });
      }
    } catch (error) {
      setbackDrop(false);
      setSnackBar({ visibility: true, severity: "error", message: "Something went wrong while renewing Trade Reference link" });
      console.error(error);
    }
  }

  const copyURL = async (encodeString) => {
    const linkURL = AppConfig.externalUrl + "tradereferenceform/validate/" + encodeString;
    try {
      await navigator.clipboard.writeText(linkURL);
      setCopy(true);
      setSnackBar({ visibility: true, severity: "success", message: "Copied to Clipboard" });
    } catch (err) {
      setSnackBar({ visibility: true, severity: "error", message: "Failed to copy to Clipboard" });
    }
  }

  return (
    <div>
      <Backdrop open={backdropOpen} className={classes.backdrop}>
        <CircularProgress color="secondary" />
      </Backdrop>

      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={snack.visibility} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={snack.severity}>
          {snack.message}
        </Alert>
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={successSnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Success!
        </Alert>
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={copySnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Copied to Clipboard!
        </Alert>
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={failSnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Server Error!
        </Alert>
      </Snackbar>
      <Grid container spacing={1} alignItems="flex-end" className={classes.searchGrid}>
        <Grid item xs={12} sm={12} md={12} lg={8}></Grid>
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <Paper component="form" className={classes.root}>
            <InputBase className={classes.input} placeholder="Search" onChange={handleSearch} />
            <SearchIcon />
          </Paper>
        </Grid>
      </Grid>

      <Accordion component={Paper} expanded={true}>
        <AccordionSummary className={classes.accordionSummary}>
          <Typography className={classes.accordionHeading}>Search Filters</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Grid container spacing={1} className={classes.filterGrid}>
            <Grid item lg={1} sm={2} xs={12}>
              <Typography className={classes.filterLabel}>Form Status :</Typography>
            </Grid>
            <Grid item lg={1.5} md={2}>
              <FormControlLabel
                className={classes.checkBox}
                control={
                  <Checkbox
                    className={classes.checkBox}
                    size="small"
                    name="completed"
                    checked={formStatusFilters.completed}
                    onChange={handleFormStatusFilters}
                    color="Secondary"
                  />
                }
                label={<span style={{ fontSize: 13 }}>Completed</span>}
              />
            </Grid>
            <Grid item lg={1.5} md={2}>
              <FormControlLabel
                className={classes.checkBox}
                control={
                  <Checkbox
                    className={classes.checkBox}
                    size="small"
                    name="drafted"
                    checked={formStatusFilters.drafted}
                    onChange={handleFormStatusFilters}
                    color="Secondary"
                  />
                }
                label={<span style={{ fontSize: 13 }}>Drafted</span>}
              />
            </Grid>
            <Grid item lg={1.5} md={2}>
              <FormControlLabel
                className={classes.checkBox}
                control={
                  <Checkbox
                    className={classes.checkBox}
                    size="small"
                    name="pending"
                    checked={formStatusFilters.pending}
                    onChange={handleFormStatusFilters}
                    color="Secondary"
                  />
                }
                label={<span style={{ fontSize: 13 }}>Pending</span>}
              />
            </Grid>
            <Grid item lg={1.5} md={2}>
              <FormControlLabel
                className={classes.checkBox}
                control={
                  <Checkbox
                    className={classes.checkBox}
                    size="small"
                    name="deactivated"
                    checked={formStatusFilters.deactivated}
                    onChange={handleFormStatusFilters}
                    color="Secondary"
                  />
                }
                label={<span style={{ fontSize: 13 }}>Deactivated</span>}
              />
            </Grid>
            <Grid item lg={1.5} md={2}>
              <FormControlLabel
                className={classes.checkBox}
                control={
                  <Checkbox
                    className={classes.checkBox}
                    size="small"
                    name="rejected"
                    checked={formStatusFilters.rejected}
                    onChange={handleFormStatusFilters}
                    color="Secondary"
                  />
                }
                label={<span style={{ fontSize: 13 }}>Rejected</span>}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {!backdropOpen && (
        <Fragment>
          <TableContainer className={classes.tableContainer} component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell
                    align="center"
                    className={classes.column}
                    onClick={() => setSortColumnValue("Partner Company")}
                  >
                    Partner Company {renderIndicator("Partner Company")}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.column}
                    onClick={() => setSortColumnValue("Reference Company")}
                  >
                    Reference Company {renderIndicator("Reference Company")}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.column}
                    onClick={() => setSortColumnValue("Contact Email")}
                  >
                    Contact Email {renderIndicator("Contact Email")}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.column}
                    onClick={() => setSortColumnValue("Form Status")}
                  >
                    Form Status {renderIndicator("Form Status")}
                  </TableCell>
                  <TableCell align="center" className={classes.column}>
                    Renew Link
                  </TableCell>
                  <TableCell align="center" className={classes.column}>
                    Copy URL
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTradeReferences.length > 0 &&
                  filteredTradeReferences
                    .filter(
                      (item) =>
                        (item.companyName
                          ? (item.companyName || "").toLowerCase().includes((searchInput || "").toLowerCase())
                          : (item.tempCompanyName || "").toLowerCase().includes((searchInput || "").toLowerCase())) ||
                        (item.resellerCompanyName || "").toLowerCase().includes((searchInput || "").toLowerCase()) ||
                        (item.email || "").toLowerCase().includes((searchInput || "").toLowerCase())
                    )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((tradeRef, index) => (
                      <TableRow key={index} onClick={() => openTradeRef(tradeRef)} className={classes.tableRow1}>
                        <TableCell align="center">
                          {tradeRef.resellerCompanyName}
                        </TableCell>
                        <TableCell align="center">
                          {tradeRef.companyName || tradeRef.tempCompanyName}
                        </TableCell>
                        <TableCell align="center">{tradeRef.email}</TableCell>
                        <TableCell
                          style={{ textTransform: "capitalize" }}
                          align="center"
                        >
                          <Typography
                            className={
                              tradeRef.status === "drafted"
                                ? classes.resultChipSecondary
                                : classes.resultChipPrimary
                            }
                          >
                            {tradeRef.status === TRADE_REFERENCE_STATUS.COMPLETED
                              ? TRADE_REFERENCE_STATUS.COMPLETED
                              : tradeRef.status === "pending"
                              ? TRADE_REFERENCE_STATUS.PENDING
                              : tradeRef.status === TRADE_REFERENCE_STATUS.DRAFTED
                              ? TRADE_REFERENCE_STATUS.DRAFTED
                              : tradeRef.status === TRADE_REFERENCE_STATUS.DEACTIVATED
                              ? TRADE_REFERENCE_STATUS.DEACTIVATED
                              : tradeRef.status === TRADE_REFERENCE_STATUS.REJECTED
                              ? TRADE_REFERENCE_STATUS.REJECTED
                              : tradeRef.status === "active"
                              ? TRADE_REFERENCE_STATUS.ACTIVE
                              : TRADE_REFERENCE_STATUS.DEFAULT}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              renewTradeReferenceLink(tradeRef.linkId);
                            }}
                          >
                            <CachedIcon
                              color="primary"
                              className={classes.renewButton}
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell align="center">
                          {(checkIfRoleExists(roles.admin) || checkIfRoleExists(roles.channelManager) || checkIfRoleExists(roles.finance) || checkIfRoleExists(roles.legal)) && (
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                copyURL(tradeRef.encodeString);
                              }}
                            >
                              <FileCopyIcon
                                color="primary"
                                className={classes.copyButton}
                              />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredTradeReferences.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Fragment>
      )}

      {!backdropOpen &&
        filteredTradeReferences.filter(
          (item) =>
            (item.companyName
              ? (item.companyName || "").toLowerCase().includes((searchInput || "").toLowerCase())
              : (item.tempCompanyName || "").toLowerCase().includes((searchInput || "").toLowerCase())) ||
            (item.resellerCompanyName || "").toLowerCase().includes((searchInput || "").toLowerCase()) ||
            (item.email || "").toLowerCase().includes((searchInput || "").toLowerCase())
        ).length === 0 && (
          <Typography className={classes.msgTypo} variant="body2">
            No Trade References Found
          </Typography>
        )}
    </div>
  );
};

export default TradeReferences;
